import { render, staticRenderFns } from "./AcademyStarsDisplay.vue?vue&type=template&id=6204de7e&scoped=true"
import script from "./AcademyStarsDisplay.vue?vue&type=script&lang=js"
export * from "./AcademyStarsDisplay.vue?vue&type=script&lang=js"
import style0 from "./AcademyStarsDisplay.vue?vue&type=style&index=0&id=6204de7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6204de7e",
  null
  
)

export default component.exports